import { FormItem } from '@/components';
import styled from 'styled-components';
import { DEVICES } from '../../../../shared/theme/theme';

export const StyledFormSectionGrid = styled.div`
  width: 100%;
  display: grid;
  column-gap: 1rem;
  grid-template-columns: 1fr;

  @media screen and ${DEVICES.LAPTOP_S} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const StyledFullWidthGidItem = styled(FormItem)`
  grid-column: 1 / -1;
`;
